import { Clear, PermIdentityOutlined } from '@material-ui/icons';
import { observer } from 'mobx-react';
import { IconButton } from '@roc/ui';
import { useQuoteTypeStore } from '../../../hooks/useQuoteTypeStore';
import { FORM_MAX_WIDTH } from '../../../utils/constants';
import { LoanSubType } from '@roc/feature-utils';
import { OneToolCard } from '../../common/oneToolCard';
import { BorrowerInformationForm } from './borrowerInformationForm';

export const BorrowerFormCard = observer(({ borrowerFormStore }) => {
  const { quoteTypeStore } = useQuoteTypeStore();
  const isSingleProperty = quoteTypeStore.loanSubtype === LoanSubType.SINGLE_PROPERTY;
  const { borrowersStore } = quoteTypeStore;
  return (
    <OneToolCard
      maxWidth={FORM_MAX_WIDTH}
      icon={PermIdentityOutlined}
      title="Add Borrower"
      actions={
        <IconButton
          testId="remove-borrower"
          aria-label="Remove borrower"
          onClick={() => borrowersStore.removeBorrower(borrowerFormStore.key)}
        >
          <Clear />
        </IconButton>
      }
    >
      <BorrowerInformationForm
        store={borrowerFormStore}
        showActions={false}
        displayPGField
        onDeleteClick={() => null}
        showTitle={false}
      />
    </OneToolCard>
  );
});
